import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const { user, profile, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(profile?.role)) {
    // Redirect to appropriate dashboard based on role
    switch (profile?.role) {
      case 'super_admin':
        return <Navigate to="/admin/super" replace />
      case 'school_admin':
        return <Navigate to="/admin/school" replace />
      case 'teacher':
        return <Navigate to="/teacher" replace />
      case 'parent':
        return <Navigate to="/parent" replace />
      case 'student':
        return <Navigate to="/student" replace />
      default:
        return <Navigate to="/" replace />
    }
  }

  return children
}